






































































import moment, { Moment } from 'moment'

import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'

import {
  InfiniteScroll,
  NetworkErrorEmptyState,
  OrderPaymentTile,
  OrderTile,
  PaceMaker,
  VsLoading
} from '@/components'

import { EmptyState, ListHeader, MobileLayout } from '@/layouts/components'

import { ActionButton, AsyncState, OrderPayment } from '@/models'

import { RootState } from '@/store/state'

import { isFood } from '@/utils'

@Component({
  components: {
    EmptyState,
    InfiniteScroll,
    ListHeader,
    MobileLayout,
    NetworkErrorEmptyState,
    OrderPaymentTile,
    OrderTile,
    PaceMaker,
    VsLoading
  }
})
export default class OrderPayments extends Vue {
  loadState = new AsyncState()

  now = moment()

  get buttons (): ActionButton[] {
    return [
      {
        icon: 'filter_list',
        color: 'dark',
        handler: () => { this.$router.push({ name: 'ChangeOrderPaymentFilters' }) }
      }
    ]
  }

  get orderPaymentGroups () {
    return this.orderGroupsByDay
  }

  get total (): number {
    return this.orderPayments.length
  }

  get emptyStateIcon () {
    return isFood() ? 'restaurant_menu' : 'list_alt'
  }

  @State((state: RootState) => state.ordering.orderPayments.isDefaultFilters)
  readonly isDefaultFilters!: boolean

  @State((state: RootState) => state.ordering.orderPayments.didLoadAll)
  readonly didLoadAll!: boolean

  @Getter('ordering/filteredOrderPayments')
  readonly orderPayments!: OrderPayment[]

  @Getter('ordering/orderPaymentGroupsByDay')
  readonly orderGroupsByDay!: { day: Moment; groupedOrderPayments: Record<'lastUpdate', Date>[]; isToday: boolean }[]

  @Action('ordering/loadOrderPaymentPage')
  loadOrderPaymentPage!: () => Promise<void>

  created () {
    if (this.total === 0) {
      this.reload()
    } else {
      this.loadState.touch()
    }
  }

  async reload () {
    try {
      await this.loadMore()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async loadMore () {
    await this.loadState.handle(
      this.loadOrderPaymentPage()
    )

    return this.orderPayments.length > 0
  }
}
